import {
  getDefaultIterations as getDefaultIterationsApi,
  getIterations as getIterationsApi
} from 'common/services/iterations.service';
import { getIterationsSucceed, setHasIterations } from '../actions';
import { PERIODS } from 'components/PeriodPicker/periods/constants';
import moment from 'moment';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';
import { DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS } from 'views/root/views/home/views/dashboard/doraV2/dashboard.doraV2.freeTier.consts';

export const getDefaultIterations =
  (params, options = {}) =>
  async dispatch => {
    try {
      let iterations = await getDefaultIterationsApi(params);

      if (options.freeTier) {
        const [firstIteration] = iterations;
        const endDate = moment().format(SEARCH_DATE_FORMAT);

        iterations = [
          {
            ...firstIteration,
            name: PERIODS.PAST_90_DAYS.menuName,
            completed_at: endDate,
            end_date: endDate,
            start_date: moment()
              .subtract(DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS, 'days')
              .format(SEARCH_DATE_FORMAT)
          }
        ];
      }

      dispatch(setHasIterations(!!iterations.length));
      dispatch(getIterationsSucceed(iterations, options));
      return iterations;
    } catch (e) {
      throw e;
    }
  };
export const getIterations =
  (params, options = {}) =>
  async dispatch => {
    try {
      const iterations = await getIterationsApi(params);
      dispatch(getIterationsSucceed(iterations, options));
      return iterations;
    } catch (e) {
      throw e;
    }
  };
